<template>
  <div class="rating-select">
    <div class="rating-type border-bottom-1px">
      <span @click="select(2)" class="block positive" :class="{'active':selectType===2}">{{desc.all}}<span
        class="count">{{ratings.length}}</span></span>
      <span @click="select(0)" class="block positive" :class="{'active':selectType===0}">{{desc.positive}}<span
        class="count">{{positives.length}}</span></span>
      <span @click="select(1)" class="block negative" :class="{'active':selectType===1}">{{desc.negative}}<span
        class="count">{{negatives.length}}</span></span>
    </div>
    <div @click="toggleContent" style="display: none" class="switch" :class="{'on':onlyContent}">
      <span class="icon-check_circle"></span>
      <span class="text">{{ $t('store.comments_with_content') }}</span>
    </div>
  </div>
</template>

<script>
const POSITIVE = 0
const NEGATIVE = 1
const ALL = 2

const EVENT_TOGGLE = 'toggle'
const EVENT_SELECT = 'select'

export default {
  props: {
    ratings: {
      type: Array,
      default () {
        return []
      }
    },
    selectType: {
      type: Number,
      default: ALL
    },
    onlyContent: {
      type: Boolean,
      default: false
    },
    desc: {
      type: Object,
      default () {
        return {
          all: this.$t('store.comments.all'),
          positive: this.$t('store.comments.positive'),
          negative: this.$t('store.comments.negative')
        }
      }
    }
  },
  computed: {
    positives () {
      return this.ratings.filter((rating) => {
        return rating.geval_scores > 2
      })
    },
    negatives () {
      return this.ratings.filter((rating) => {
        return rating.geval_scores <= 2
      })
    }
  },
  methods: {
    select (type) {
      this.$emit(EVENT_SELECT, type)
    },
    toggleContent () {
      this.$emit(EVENT_TOGGLE)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">

  .rating-select
    .rating-type
      padding: 0.9rem 0
      margin: 0 0.9rem
      .block
        display: inline-block
        padding: 0.4rem 0.6rem
        margin-right: 0.4rem
        line-height: 0.8rem
        border-radius: 1px
        font-size:0.6rem
        color: #666
        &.active
          color:#fff
        .count
          margin-left: 0.1rem
        &.positive
          background: rgba(0,160,220,.2);
          &.active
            background: #00a0dc
        &.negative
          background: #ccc
          &.active
            background:#666
    .switch
      display: flex
      align-items: center
      padding: 0.6rem 0.9rem
      line-height: 1.2rem
      border-bottom: 1px solid $color-row-line
      color: #999
      &.on
        .icon-check_circle
          color: #00b43c
      .icon-check_circle
        margin-right: 0.2rem
        font-size: 1.2rem
      .text
        font-size:0.6rem
</style>
